import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconTiktokStyle0 = cosmosIconCss;

const CosmosIconTiktok$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconTiktok extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '0a061a321f09b2bec28a851058c6c6fc616ab36b', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '44fc87288585e2afb5572270fedb9054dc8b2273', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'fbfeac97a67f9bcd7530f3aa352b98b979402366', d: "M17.175 10.219a5.755 5.755 0 0 1-3.385-1.093v4.975a4.56 4.56 0 0 1-.8 2.579 4.489 4.489 0 0 1-2.112 1.658 4.442 4.442 0 0 1-2.672.148 4.476 4.476 0 0 1-2.28-1.415 4.562 4.562 0 0 1-.561-5.126 4.502 4.502 0 0 1 1.919-1.883 4.445 4.445 0 0 1 2.639-.445v2.503a2.04 2.04 0 0 0-1.27.011 2.06 2.06 0 0 0-1.02.761 2.091 2.091 0 0 0 .014 2.438 2.04 2.04 0 0 0 2.3.745 2.06 2.06 0 0 0 1.025-.755 2.09 2.09 0 0 0 .391-1.219V4.375h2.427c-.002.207.015.413.051.617a3.396 3.396 0 0 0 1.487 2.233c.548.366 1.19.561 1.847.561v2.433Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconTiktokStyle0; }
}, [1, "cosmos-icon-tiktok", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-tiktok"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-tiktok":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconTiktok$1);
            }
            break;
    } });
}

const CosmosIconTiktok = CosmosIconTiktok$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconTiktok, defineCustomElement };
